import { Component, OnInit, ViewChild } from '@angular/core';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { BooleanCheckOrCrossViewColumn, BooleanValuesViewColumn, CurrencyViewColumn, Datalistviewcolumn, DateRangeViewColumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { PurchasingOptionFilterComponent } from 'src/app/shared/datalistview/filters/purchasing-option-filter/purchasing-option-filter.component';

@Component({
    templateUrl: './permittypes.component.html',
    styleUrls: ['./permittypes.component.scss'],
    standalone: false
})
export class PermittypesComponent implements OnInit {
  @ViewChild(PurchasingOptionFilterComponent) purchasingOptionFilter?: PurchasingOptionFilterComponent;

  public orgService: OrganizationsService;
  public Subsets: string[] = [];
  public Columns: Datalistviewcolumn[] = [];


  constructor(orgService: OrganizationsService) {
    this.orgService = orgService;
    this.Subsets = ['active', 'expired', 'pending']
    this.Columns = [
      new Datalistviewcolumn("Name", "Name"),
      new Datalistviewcolumn("External ID", "ExternalId"),
      new Datalistviewcolumn("Price", "PriceString"),
      new Datalistviewcolumn("Active Start Date", "ActiveStartDateLocalFriendlyString"),
      new Datalistviewcolumn("Active End Date", "ActiveEndDateLocalFriendlyString"),
      new Datalistviewcolumn("User Count", "UserInfoString"),
      new Datalistviewcolumn("Active Permits", "PermitsAllocatedString"),
      new Datalistviewcolumn("Purchase Type", "PurchasingOption"),
    ];
  }

  ngOnInit(): void {
  }

}
